// 手机号码验证
let phoneReg = (phoneNumber) => {
  let reg = /^[1][3-9][0-9]{9}$/
  return reg.test(phoneNumber)
}

// 不足10补0
let formatNumber = function (n) {
  n = n.toString()
  return n[1] ? n : '0' + n
}

// 输出03:05:59  时分秒
let secondToDate = (result) => {
  if (!result) return '00:00:00';
  var h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
  var m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
  var s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
  return result = (~~h <= 0 ? '00' : h) + ":" + (~~m <= 0 ? '00' : m) + ":" + (~~s <= 0 ? '00' : s);
}

// 将时间戳格式化成基本格式时间(yyyy-MM-dd hh:mm:ss q S)
let formatTime = (date, fmt = 'yyyy-MM-dd hh:mm:ss') => {
  if (!date) {
    return
  }
  if (date=="长期有效") {
    return "长期有效"
  }
  // 处理日期字符串，如果包含微秒部分，删除掉
  if (typeof date === 'string') {
    // 删除多余的微秒部分，保留毫秒部分
    date = date.replace(/\.\d{3,6}Z$/, 'Z');  // 如果日期是类似 2024-10-29T02:44:41.000000Z，则变成 2024-10-29T02:44:41Z
  }
  // 如果日期格式中含有空格（非ISO格式），将其转换为ISO格式
  if (typeof date === 'string' && date.indexOf(' ') !== -1) {
    date = date.replace(' ', 'T'); // 替换空格为'T'
  }
  // 如果日期中有"."，则转换为"-"（符合ISO格式）
  if (typeof date === 'string' && date.indexOf('.') !== -1) {
    date = date.replace(/\./g, '-'); // 替换所有的"."为"-"
  }
  let time = new Date(date)
  var o = {
    'M+': formatNumber(time.getMonth() + 1), // 月份
    'd+': formatNumber(time.getDate()), // 日
    'h+': formatNumber(time.getHours()), // 小时
    'm+': formatNumber(time.getMinutes()), // 分
    's+': formatNumber(time.getSeconds()), // 秒
    'q+': Math.floor((time.getMonth() + 3) / 3), // 季度
    'S': time.getMilliseconds() // 毫秒
  }
  // var o = {
  //   'M+': time.getMonth() + 1, // 月份
  //   'd+': time.getDate(), // 日
  //   'h+': time.getHours(), // 小时
  //   'm+': time.getMinutes(), // 分
  //   's+': time.getSeconds(), // 秒
  //   'q+': Math.floor((time.getMonth() + 3) / 3), // 季度
  //   'S': time.getMilliseconds() // 毫秒
  // }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (time.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? formatNumber(o[k]) : ['h+', 'm+', 's+', 'S+'].includes(k) ? formatNumber(o[k]) : o[k])
    }
  }
  return fmt
}

// 两个时间相关的天数
let getDaysBetween = (dateString1, dateString2) => {
  var startDate = Date.parse(dateString1);
  var endDate = Date.parse(dateString2);
  var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
  // alert(days);
  return ~~days;
}

// 获取传入时间与今天相差天数
let getOffsetDay = date => {
  let time = new Date(date)
  // 设置当前时间为00:00:00的时间戳
  let time0 = new Date(time.toLocaleDateString()).getTime()
  let nowTime0 = new Date(new Date().toLocaleDateString()).getTime()
  return (nowTime0 - time0) / (1000 * 60 * 60 * 24)
}

function formatTime5(time) {
  const now = new Date();
  const inputTime = new Date(time);
  // 获取今日和明日的开始时间
  const todayStart = new Date(now.setHours(0, 0, 0, 0));
  const tomorrowStart = new Date(todayStart);
  tomorrowStart.setDate(todayStart.getDate() + 1);
  const dayAfterTomorrowStart = new Date(tomorrowStart);
  dayAfterTomorrowStart.setDate(tomorrowStart.getDate() + 1);
  const isToday = inputTime >= todayStart && inputTime < tomorrowStart;
  const isTomorrow = inputTime >= tomorrowStart && inputTime < tomorrowStart.setDate(tomorrowStart
    .getDate() + 1);
  const isDayAfterTomorrow = inputTime >= dayAfterTomorrowStart && inputTime < dayAfterTomorrowStart.setDate(dayAfterTomorrowStart.getDate() + 1);
  const timeString = inputTime.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });

  if (isToday) {
    return `今天 ${timeString}`;
  } else if (isTomorrow) {
    return `明天 ${timeString}`;
  } else if (isDayAfterTomorrow) {
    return `后天 ${timeString}`;
  } else {
    return `${formatTime(time, "MM")}月${formatTime(time, "dd")}日 ${formatTime(time, "hh:mm")}`;
  }
}
// 将时间戳格式化成时间（20:36 || 昨天 20:26 || 前天 20:16 || 2024.10.09)
let formatTime1 = date => {
  if (!date) {
    return
  }
  // 相差天数
  let dayOffset = getOffsetDay(date)
  if (dayOffset === 0) {
    return formatTime(date, 'hh:mm')
  } else if (dayOffset === 1) {
    return formatTime(date, '昨天 hh:mm')
  }else if (dayOffset === 2) {
    return formatTime(date, '前天 hh:mm')
  } else {
    return formatTime(date, 'yyyy.MM.dd')
  }
}

// 将时间戳格式化成时间（00:00||8月23日)
let formatTime2 = date => {
  if (!date) {
    return
  }
  // 相差天数
  let dayOffset = getOffsetDay(date)
  if (dayOffset === 0) {
    return ""
  } else if(dayOffset === -1){
    return formatTime(date, '明天')
  } else {
    return formatTime(date, 'MM月dd日')
  }
}

// 将时间戳格式化成时间（今天||昨天||8月23日)
let formatTime3 = date => {
  if (!date) {
    return
  }
  // 相差天数
  let dayOffset = getOffsetDay(date)
  // console.log(dayOffset)
  if (dayOffset === 0) {
    return '今天'
  } else if (dayOffset === 1) {
    return '昨天'
  } else {
    return formatTime(date, 'MM月dd日')
  }
}

// 将时间戳格式化成时间（今天 08:00 || MM月dd日)
let formatTime4 = date => {
  if (!date) {
    return
  }
  // 相差天数
  let dayOffset = getOffsetDay(date)
  // console.log(dayOffset)
  if (dayOffset === 0) {
    return formatTime(date, '今天 hh:mm')
  } else {
    return formatTime(date, 'MM月dd日')
  }
}

// 将时间戳格式化成时间（已上线||今天 hh:mm||明天 hh:mm||后天 hh:mm||11月25日 hh:mm)
let formatTime6 = date => {
  if (!date) {
    return
  }
  // 相差天数
  let dayOffset = getOffsetDay(date)
  if (dayOffset === 0) {
    let time = new Date(date).getTime()
    let nowTime = new Date().getTime()
    if (time<nowTime) return formatTime(date, '已上线')
    return formatTime(date, '今天 hh:mm 上线')
  } else if(dayOffset === -1){
    return formatTime(date, '明天 hh:mm 上线')
  }else if(dayOffset === -2){
    return formatTime(date, '后天 hh:mm 上线')
  }else{
    return `${Math.abs(dayOffset)}天后上线`
  }
}

// 将时间戳格式化成时间（今天 hh:mm || 明天 hh:mm || 25日 hh:mm)
let formatTime7 = date => {
  if (!date) {
    return
  }
  // 相差天数
  let dayOffset = getOffsetDay(date)
  if (dayOffset === 0) {
    return formatTime(date, '今天 hh:mm')
  } else if(dayOffset === -1){
    return formatTime(date, '明天 hh:mm')
  }else{
    return formatTime(date, 'dd日 hh:mm')
  }
}

// 将时间戳格式化成时间（ 08:00 || MM月dd日)
let formatTime8 = date => {
  if (!date) {
    return
  }
  // 相差天数
  let dayOffset = getOffsetDay(date)
  // console.log(dayOffset)
  if (dayOffset === 0) {
    return formatTime(date, 'hh:mm')
  } else {
    return formatTime(date, 'MM月dd日 hh:mm')
  }
}

const formatTime9 = (time, type = 0) => {
  const offsetDay = getOffsetDay(time);
  const timeStr = formatTime(time, "hh:mm");
  
  const typeHandlers = {
    0: () => {
      const daysMap = { 0: "今天", [-1]: "明天", [-2]: "后天" };
      return `${daysMap[offsetDay] || ""}上线`;
    },
    1: () => {
      const daysMap = { 0: "今天", [-1]: "明天", [-2]: "后天" };
      return daysMap[offsetDay] 
        ? `${daysMap[offsetDay]}<span class="DIN_SPAN">${timeStr}</span>上线`
        : `<span class="DIN_SPAN">${Math.abs(offsetDay)}</span>天后上线`;
    },
    2: () => {
      const daysMap = { 0: "今天", 1: "昨天" };
      return `${daysMap[offsetDay] || ""}上线`;
    },
    3: () => {
      if (offsetDay === 0) return `今天<span class="DIN_SPAN">${timeStr}</span>上线`;
      if (offsetDay === 1) return `昨天<span class="DIN_SPAN">${timeStr}</span>上线`;
      return `已上线<span class="DIN_SPAN">${offsetDay}</span>天`;
    },
    4: () => {
      if (offsetDay === 0) return `今天<span class="DIN_SPAN">${timeStr}</span>上线`;
      return ``;
    },
    5: () => {
      if (offsetDay === 0) return `今天<span class="DIN_SPAN2">${timeStr}</span>上线`;
      return ``;
    },
  };

  return typeHandlers[type] ? typeHandlers[type]() : `上线`;
};
// 格式化价格(100.00)
let formatPrice = data => {
  if (!data) {
    return '0.00'
  }
  return (data / 100).toFixed(2)
}

// 格式化价格(100)
let formatPrice1 = data => {
  if (!data) {
    return 0
  }
  return data / 100
}

// 格式化价格(+100)
let formatPrice2 = data => {
  if (!data) {
    return 0
  }
  if (data > 0) {
    return '+' + data / 100
  } else {
    return data / 100
  }
}
// 格式化视频()
let videoSrc = data => {
  let obj = data.game_list;
  if (obj) {
    if (obj.length > 0) {
      for (let i = 0; i < obj.length; i++) {
        if (obj[i].videos.length > 0) {
          // return obj[i].cdn_host + obj[i].videos[0].url;
          return obj[i].videos[0].url;
        }
      }
    } else {
      return '';
    }
  } else {
    return '';
  }
}
// 图片化视频()
let picSrc = data => {
  let obj = data.game_list;
  if (obj) {
    if (obj.length > 0) {
      for (let i = 0; i < obj.length; i++) {
        if (obj[i].videos.length > 0) {
          // return obj[i].cdn_host + obj[i].videos[0].img_url;
          return obj[i].videos[0].img_url || '';
        }
      }
    } else {
      // return require('@/assets/images/video_loading.jpg');
    }
  } else {
    // return require('@/assets/images/video_loading.jpg');
  }
}

// 数量格式化
let numberFormat = (value, w = '万') => {
  let param = {}
  let k = 10000
  let sizes = ['', w, '亿', '万亿']
  let i
  if (value < k) {
    param.value = value
    param.unit = ''
  } else {
    i = Math.floor(Math.log(value) / Math.log(k));
    param.value = ((value / Math.pow(k, i))).toFixed(2);
    param.unit = sizes[i];
  }
  return param.value + param.unit;
}

// 格式化30天内日期
const formatDateLessAMonth = (value) => {
  if (!value) return '';
  const now = new Date();
  const date = new Date(value);
  const diffTime = now.getTime() - date.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 3600 * 24));
  if (diffDays >= 30) {
    return '重磅推荐';
  } else {
    return (date.getMonth() + 1) + '月' + date.getDate() + '日'; // 格式化成月日
  }
}

//保留小数后一位
let getRoundedNumber = date => {
  if (typeof date === 'number') {
    return (date * 10).toFixed(1);
  } else {
    let data1 = parseFloat(date);
    return (data1 * 10).toFixed(1);
  }
}
const filters = {
  phoneReg,
  formatTime,
  formatNumber,
  formatTime1,
  formatTime2,
  formatTime3,
  formatTime4,
  formatTime5,
  formatTime6,
  formatTime7,
  formatTime8,
  formatTime9,
  formatPrice,
  formatPrice1,
  formatPrice2,
  videoSrc,
  picSrc,
  getDaysBetween,
  secondToDate,
  numberFormat,
  formatDateLessAMonth,
  getRoundedNumber,
}
export default filters
